'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
var PropTypes = require('prop-types');
var ToolTip = require('./ToolTip.js');
var RateTableAnalytics_constants = require('./RateTableAnalytics.constants-44d282ef.js');
var RateTable_content = require('./RateTable.content-1c40a68f.js');
var react = require('@linaria/react');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var jsxRuntime = require('react/jsx-runtime');
require('./FontIcon.js');
require('@babel/runtime/helpers/defineProperty');
require('deepmerge');
require('./mortgageRates.constants-43194cde.js');
require('./Typography-d8cec00c.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

var LoanTableWrapper = /*#__PURE__*/react.styled('div')({
  name: "LoanTableWrapper",
  "class": "l1dt9ztc",
  propsAsIs: false
});

/**
 * rowBuilder - builds the table rows with the loan data
 */
var rowBuilder = function rowBuilder(rates) {
  formatLoans(rates);
  var loanRows = [];
  rates.map(function (loan) {
    loanRows.push(singleRow(loan));
  });
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: loanRows
  });
};
var singleRow = function singleRow(loan) {
  var label = loan.label,
    url = loan.url,
    rate = loan.rate,
    apr = loan.apr,
    calculatedMonthlyPayment = loan.calculatedMonthlyPayment;
  var _loan$discountPoints = loan.discountPoints,
    raw = _loan$discountPoints.raw,
    cost = _loan$discountPoints.cost;
  return /*#__PURE__*/jsxRuntime.jsxs("tr", {
    className: "table-row",
    children: [/*#__PURE__*/jsxRuntime.jsx("td", {
      className: "table-data-label",
      children: createLink(label, url)
    }), /*#__PURE__*/jsxRuntime.jsxs("td", {
      children: [rate.toFixed(3), "%"]
    }), /*#__PURE__*/jsxRuntime.jsxs("td", {
      children: [apr.toFixed(3), "%"]
    }), /*#__PURE__*/jsxRuntime.jsxs("td", {
      children: [/*#__PURE__*/jsxRuntime.jsx("span", {
        children: raw
      }), " ", /*#__PURE__*/jsxRuntime.jsxs("span", {
        children: ["($", cost.toFixed(2), ")"]
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("td", {
      children: ["$", calculatedMonthlyPayment.toFixed(2)]
    })]
  }, label);
};

/**
 * links the loan label to a page if URL exists for loan
 */
var createLink = function createLink(label, url) {
  if (url) return /*#__PURE__*/jsxRuntime.jsx("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer",
    title: label,
    children: label
  });
  return label;
};

/**
 * formatLoans
 * 1. sets priority for each loan then
 * 2. sorts the rates object based on defined priority
 */
var formatLoans = function formatLoans(rates) {
  rates.map(function (loan) {
    setLoanPriority(loan);
    setLoanURL(loan);
  });
  sortLoans(rates);
  return rates;
};

/**
 * sortLoans - sorts rates object based on loan[priority] value
 */
var sortLoans = function sortLoans(loans) {
  loans.sort(function (a, b) {
    return a.priority < b.priority ? -1 : 1;
  });
  return loans;
};

/**
 * adds sorting priority {priority: 1} to loan object
 */
var setLoanPriority = function setLoanPriority(loan) {
  var abbrevPriority = getPropIfStringContainsKey(loan.label, abbreviatedLoanTypePriority);
  var amortizationPriority = getPropIfStringContainsKey(loan.label, amortizationTypePriority);
  var termPriority = getPropIfStringContainsKey(loan.label, termTypePriority);
  // group and sort rates by abbreviation (FHA, VA), then amortization type, then by term.
  var priority = abbrevPriority * 100 + amortizationPriority * 10 + termPriority;
  loan.priority = priority;
  return loan;
};

/**
 * Returns the value of the first key in the object found within the string, otherwise returns the default value.
 */
var getPropIfStringContainsKey = function getPropIfStringContainsKey(string, obj) {
  var _Object$entries$find$, _Object$entries$find;
  var defaultReturnValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return (_Object$entries$find$ = (_Object$entries$find = Object.entries(obj).find(function (_ref) {
    var _ref2 = _slicedToArray__default["default"](_ref, 2),
      key = _ref2[0];
      _ref2[1];
    return string.toLowerCase().includes(key);
  })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1]) !== null && _Object$entries$find$ !== void 0 ? _Object$entries$find$ : defaultReturnValue;
};

/**
 * adds URL to each loans object {url: '#'}
 */
var setLoanURL = function setLoanURL(loan) {
  var _assumptionPathsMap$f;
  var path = (_assumptionPathsMap$f = assumptionPathsMap.find(function (obj) {
    return matchLabelWithName(loan.label, obj.name);
  })) === null || _assumptionPathsMap$f === void 0 ? void 0 : _assumptionPathsMap$f.path;
  if (path) {
    loan.url = "".concat(baseAssumptionsUrl).concat(path);
  }
  return loan;
};

/**
 * checks loan.label for specified string and returns boolean
 */
var matchLabelWithName = function matchLabelWithName(label, name) {
  if (label.toLowerCase().startsWith(name.toLowerCase())) return true;
  return false;
};
var abbreviatedLoanTypePriority = {
  fha: 1,
  va: 2,
  jumbo: 3
};
var amortizationTypePriority = {
  fixed: 1,
  arm: 2
};
var termTypePriority = {
  '30-year': 1,
  '15-year': 2,
  '10-year': 3,
  '7-year': 4,
  '5-year': 5
};
var baseAssumptionsUrl = 'https://www.rate.com/';

/**
 * Mapping of loan type to assumption urls.
 */
var assumptionPathsMap = [{
  name: 'FHA',
  path: 'mortgage-rates/assumptions/fha_30-year_fixed_conforming'
}, {
  name: 'VA',
  path: 'mortgage-rates/assumptions/va_30-year_fixed_conforming'
}, {
  name: 'Jumbo',
  path: 'home-loans/jumbo-mortgage'
}, {
  name: '30-year fixed',
  path: 'mortgage-rates/assumptions/30-year_fixed_conforming'
}, {
  name: '15-year fixed',
  path: 'mortgage-rates/assumptions/15-year_fixed_conforming'
}, {
  name: '10-year ARM',
  path: 'mortgage-rates/assumptions/10-year_arm_conforming'
}, {
  name: '7-year ARM',
  path: 'mortgage-rates/assumptions/7-year_arm_conforming'
}, {
  name: '5-year ARM',
  path: 'mortgage-rates/assumptions/5-year_arm_conforming'
}];

({
  rates: PropTypes__default["default"].array.isRequired
});
var LoanTable = function LoanTable(_ref) {
  var rates = _ref.rates;
  var thead = RateTable_content.staticContent.tableHeadings,
    paymentHelper = RateTable_content.staticContent.paymentHelper,
    pointsHelper = RateTable_content.staticContent.pointsHelper;
  var handleMouseOver = function handleMouseOver(e, eventName) {
    RateTableAnalytics_constants.dispatchTrackingEvent(eventName, {
      srcAction: 'hover'
    }, e.currentTarget, 'RateTableInfo');
  };
  return /*#__PURE__*/jsxRuntime.jsx(LoanTableWrapper, {
    children: /*#__PURE__*/jsxRuntime.jsxs("table", {
      children: [/*#__PURE__*/jsxRuntime.jsx("thead", {
        children: /*#__PURE__*/jsxRuntime.jsxs("tr", {
          className: "table-head",
          children: [/*#__PURE__*/jsxRuntime.jsx("th", {
            children: thead[0]
          }), /*#__PURE__*/jsxRuntime.jsx("th", {
            children: thead[1]
          }), /*#__PURE__*/jsxRuntime.jsx("th", {
            children: thead[2]
          }), /*#__PURE__*/jsxRuntime.jsxs("th", {
            children: [thead[3], /*#__PURE__*/jsxRuntime.jsx(ToolTip["default"], {
              content: pointsHelper,
              offset: "right",
              iconName: "information-circle",
              onMouseOver: function onMouseOver(e) {
                return handleMouseOver(e, RateTableAnalytics_constants.ToolTipTrackingEvents.POINTS);
              }
            })]
          }), /*#__PURE__*/jsxRuntime.jsxs("th", {
            children: [thead[4], /*#__PURE__*/jsxRuntime.jsx(ToolTip["default"], {
              content: paymentHelper,
              offset: "right",
              iconName: "information-circle",
              onMouseOver: function onMouseOver(e) {
                return handleMouseOver(e, RateTableAnalytics_constants.ToolTipTrackingEvents.MONTHLY_PAYMENT);
              }
            })]
          })]
        })
      }), /*#__PURE__*/jsxRuntime.jsx("tbody", {
        children: rowBuilder(rates)
      })]
    })
  });
};

exports["default"] = LoanTable;
